<template>
  <div id="main">
    <br />
    <label style="font-size:40px;">
      Pickups - Reporte
    </label>
    
    <article class="message">
      <div class="message-body">
        <div class="columns">
          <div class="column is-2" style="padding: 1em 1em 0 1em;"> 
            Fecha actual
            <br>
            <date-pick v-model="fecha"></date-pick>
          </div>
          <!-- <div class="column is-2" style="padding: 1em 1em 0 2em;">
            Hasta <br>
            <date-pick  v-model="fechaFinal"></date-pick>
          </div> -->
          <div class="column is-3" style="padding: 1em 1em 0 3em;" >
            <br>
            <a @click="setFecha()" class="button is-info is-small">Mostrar Pickups</a>
            <!-- <a class="button is-warning is-small" @click="setRange">Establecer</a> -->
          </div>
          <div class="column is-2">
          </div>
          <div class="column is-2" align="right"> <br>
            <input class="input is-small" v-model="searchText" placeholder="Buscar por nombre ...">
          </div>
          <div class="column is-1" align="right"> <br>
            <a class="button is-small is-success" @click="tableToExcel('testTable', 'W3C Example Table')"> Exportar a Excel </a>
          </div>
        </div>
      </div>
    </article>

    <br>

    <section class="hero is-primary" v-if="transportesReservados=='no hay datos'">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Sin reservaciones asignadas
          </h1>
          <h2 class="subtitle">
            para {{dia}} 
          </h2>
        </div>
      </div>
    </section>
    <section class="hero is-primary" v-else>
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Reservaciones asignadas
          </h1>
          <h2 class="subtitle">
            Ordenadas por transporte
          </h2>
        </div>
      </div>
    </section><br>

    <!-- Reservaciones asignadas -->
    
      <table v-if="transportesReservados!='no hay datos'" style="z-index: -9; width:100%;" class="table is-bordered is-hoverable" id="testTable">
        <template v-for="transporte in transportesReservados">
        <thead :key="transporte.id">
          <tr><th class="tituloTransporte" colspan="4">{{transporte.nombre}} id.{{transporte.id}} Capacidad neta {{transporte.capacidad}} </th></tr>
          <tr>
            <th class="has-text-centered" >HOTEL</th>
            <th class="is-size-7">VENDEDOR</th>
            <th class="is-size-7" >CLIENTE</th>
            <th class="is-size-7" >HAB</th>
            <th class="is-size-7" >PAX</th>
            <th class="is-size-7" >HORA</th>
            <th class="has-text-centered" >TOUR</th>
            <th class="is-size-7" >BALANCE</th>
            <th class="is-size-7" >OBSERVACIONES</th>
          </tr>
        </thead>
        <tbody :key="transporte.id">
          <tr v-for="reserva in reservacionesAsignadasList" :key="reserva.id" v-if="reserva.transporteSalidaId==transporte.id">
            <td class="is-size-7"> {{reserva.hotelNombre}} </td>
            <td class="is-size-7"> {{reserva.vendedorNombre}} </td>
            <td class="is-size-7"> {{reserva.cliente}} </td>
            <td class="is-size-7"> {{reserva.habitacion}} </td>
            <td class="is-size-7 has-text-centered"> {{reserva.adultos}} <span v-if="reserva.ninos" >.{{reserva.ninos}}</span><span v-if="reserva.infantes" >.{{reserva.infantes}}</span> </td>
            <td class="is-size-7"><span v-if="reserva.pickup">{{reserva.pickup.substr(0,5)}}</span></td>
            <td class="is-size-7">id.{{reserva.id}} {{reserva.tour}} {{reserva.tipo}} {{reserva.desde}} {{reserva.nacionalidad}} {{reserva.idioma}} <span v-if="reserva.tipoReservacionId>1" > Combo ({{reserva.posicionReservacion}}/{{reserva.tipoReservacionId}}) </span> </td>
            <td class="is-size-7"> {{reserva.balance}} {{reserva.monedaNombre}} </td>
            <td class="is-size-7"> {{reserva.observaciones}} </td>
          </tr>
          <tr>
          <td class="is-size-7" colspan="2">
          </td>
          <td>
            </td></tr>
        </tbody>
        </template>
      </table>
    
    <!-- Termina reservaciones asignadas -->

  </div>
</template>

<script src="../toexcel.js" type="text/javascript"></script>
<script>
import searchMix from '../mixins/mixin.js'
import DatePick from 'vue-date-pick'
import VueClockPicker from '@pencilpix/vue2-clock-picker'
import axios from 'axios';
import Cors from 'cors';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
require('../mixins/mixin.js');

import Vue from 'vue'
import {
  VTooltip
} from 'v-tooltip'
import { Script } from 'vm';
Vue.use(VTooltip)


Vue.directive('tooltip', VTooltip)

export default {
  components:{
    DatePick,
    VueClockPicker
  },
  data() {
    return {
      reservacionesList:[],
      hotelesReservados:[],
      transportesList:[],
      idsToUpdate:[],
      idsList:[],
      transporteElegido:'',
      fecha:moment().add(1, 'day').format('YYYY-MM-DD'),
      restar:'',
      transportesReservados:[],
      reservacionesAsignadasList:[],
      monedasList:[],
      dia: moment(this.fecha).add(1, 'day').format('dddd'),

      loaded: false,
      userDep: $cookies.get('RhSession').id_depar,
      fechaInicial: '',
      fechaFinal: '',
      colaboradoresList: [],
      incidencia_tipo: [],
      idsColaboradores: [],
      datesInterval: [],
      incidenciasList: {},
      incidencias:{},
      commentStyle: {
        borderStyle: true
      },
      showIncidenceTable: '',
      tipoId:'',
      tipoNombre:'',
      id:'',
      key:'',
      colaborador:'',
      comentarioIncidencia:'',
      searchText:'',
      host: 'booking.sistemy.mx',
      // host: 'localhost',
      hotelesReservadosRiviera:[],
      hotelesReservadosCombos:[],

      menuComponente: 'app-create',
    }
  },
  created() {
    this.getMonedas()
    this.hotelesConReservas()
    this.hotelesConReservasCombos()
    this.hotelesConReservasRiviera()
    this.reservaciones()
    this.reservacionesAsignadas()
    this.getTransportes()
    this.transportesConReservas()
  },
  computed: {
    itemsSearched : function(){
      var self = this;
      if( self.searchText == ''){
        return self.reservacionesList;
      }
      return self.reservacionesList.filter(function(item){
        var str = self.searchText;
        var res = str.toUpperCase();
        return item.cliente.includes(str);
      });
    } 
  },
  methods: {
    setFecha () {
      console.log("setFecha");
      this.hotelesConReservas()
      this.hotelesConReservasCombos()
      this.hotelesConReservasRiviera()
      this.reservaciones()
      this.reservacionesAsignadas()
      this.getTransportes()
      this.transportesConReservas()
    },
    sumar (a,b) {
      return a+b;
    },
    guardar (index) {
      console.log("guardando cambios");
      console.log(this.reservacionesList[index].adultos,'adultos');
      console.log(this.reservacionesList[index].id,"id");
      console.log(this.itemsSearched[index].balance,'balance');
      // axios.post('http://localhost:3000/justUpdate',{
      //       table:"reservaciones",
      //       set:" adultos = "+this.itemsSearched[index].adultos+", ninos = "+this.itemsSearched[index].ninos+", infantes = "+this.itemsSearched[index].infantes+", balance = "+this.itemsSearched[index].balance+", moneda = "+this.itemsSearched[index].moneda+", observaciones = '"+this.itemsSearched[index].observaciones+"' ",
      //       where:"id="+this.itemsSearched[index].id
      //     })
      var tabla = `reservaciones`;
      var set = "adultos = "+this.itemsSearched[index].adultos+", ninos = "+this.itemsSearched[index].ninos+", infantes = "+this.itemsSearched[index].infantes+", balance = "+this.itemsSearched[index].balance+", moneda = "+this.itemsSearched[index].moneda+", observaciones = '"+this.itemsSearched[index].observaciones+"'";
      var where = "id="+this.itemsSearched[index].id;
      axios.get(`http://${this.host}/assignFunction.php?action=justUpdate&tabla=${tabla}&set=${set}&where=${where}`)
          .then((response) => {
            if (response.status == 200 ) {
              this.$snotify.success('Cambios guardados', 'Correcto', {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
            }else{
              console.log('error');
            }
          });
    },
    getMonedas(){
      var estancia = this;
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre',
        //   table: 'monedas',
        //   where: '',
        //   condition: ''
        // })
        var select = `id, nombre`;
        var tabla = "monedas";
        var where = "";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            estancia.monedasList = response.data;
          }else{
            console.log('error');
          }
        });
    },
    removerDelTransporte (reserva) {
      console.log('about to remover del transporte');
      // axios.post('http://localhost:3000/justUpdate',{
      //       table:"reservaciones",
      //       set:" transporteSalidaId = NULL ",
      //       where:"id='"+reserva.id+"'"
      //     })
      var tabla = `reservaciones`;
      var set = "transporteSalidaId = NULL";
      var where = "id='"+reserva.id+"'";
      axios.get(`http://${this.host}/assignFunction.php?action=justUpdate&tabla=${tabla}&set=${set}&where=${where}`)
          .then((response) => {
            if (response.status == 200 ) {
              console.log("reserva desasignada");
              // this.getTransportes();
              this.devolverAsientosTransporte(reserva);
            }else{
              console.log('error');
            }
          });
    },
    cambiarDeTransporte (reserva,asientos) {
      console.log("en cambiar de tranposrte"); // justUpdate a table transportes utilizados where transporteId and fecha
      if(this.transporteElegido){
        this.devolverAsientosTransporte(reserva,'1'); //Devolvemos los asientos al transporte 
        //this.updateTransporteUtilizado(reserva.hotelId,asientos,reserva.id); //restamos asientos al nuevo transporte
        this.beforeAsignar(reserva.hotelId,'1',reserva.adultos+reserva.ninos,reserva.id,'1');
      }
    },
    devolverAsientosTransporte (reserva,cambio) {
      console.log('devolviendo asientos');
      // axios.post('http://localhost:3000/justUpdate',{
      //       table:"transportes_utilizados",
      //       set:" capacidad = capacidad+("+reserva.adultos+")+("+reserva.ninos+") ",
      //       where:"transporteId="+reserva.transporteSalidaId+" and fecha='"+this.fecha+"' "
      //     })
      var tabla = `transportes_utilizados`;
      var set = "capacidad = capacidad%2B("+reserva.adultos+")%2B("+reserva.ninos+")";
      var where = "transporteId="+reserva.transporteSalidaId+" and fecha='"+this.fecha+"'";
      axios.get(`http://${this.host}/assignFunction.php?action=justUpdate&tabla=${tabla}&set=${set}&where=${where}`)
          .then((response) => {
            if (response.status == 200 ) {
              console.log("reserva desasignada");
              if(cambio!=1){
              this.$snotify.success('Devuelto a Hotel', 'Removido', {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
              this.hotelesConReservas()
              this.hotelesConReservasRiviera()
              this.reservaciones()
              this.transportesConReservas()
              this.reservacionesAsignadas()
              this.getTransportes()
              }else if(cambio==1){
                console.log(reserva,"viene de cambio de transporte");
              }
            }else{
              console.log('error');
            }
          });
    },
    beforeAsignar (hotelId,individual,asientosIndividual,reservaId,cambio) {
      console.log(asientosIndividual,'before asignar'); console.log(cambio,'cambio beforeAsignar');
      if(this.transporteElegido){
        // axios.post('http://localhost:3000/justRead', {
        //     select: '*',
        //     table: "transportes_utilizados",
        //     where: 'fecha="'+this.fecha+'" and transporteId="'+this.transporteElegido.id+'"',
        //     condition: "order by id desc limit 1"
        //   })
        var select = `*`;
        var tabla = "transportes_utilizados";
        var where = 'fecha="'+this.fecha+'" and transporteId="'+this.transporteElegido.id+'" order by id desc limit 1 ';
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
          .then((response) => {
            if (response.status == 200) {
              console.log(response.data,'hay?');
              console.log(individual,'if 1 is individual');
              if(individual!=1){
                if(response.data!='no hay datos'){
                  console.log(hotelId,"Transporte utilizado previamente");
                    this.checkForNull(hotelId);
                }else{
                  console.log("El transporte no ha sido utilizado previamente"); //Insertar el transporte en la tabla de transportes_utilizados, luego: checkFroNull();
                  this.agregarTransporteSalida('1');
                  this.checkForNull(hotelId);
                }
              }else if(individual==1){ // asignación individual
                console.log(response.data,'hay?');
                if(response.data!='no hay datos'){
                  console.log(response.data,'hay?');
                  console.log(hotelId,"Transporte utilizado previamente"); // updatear en transportes_utilizados
                  this.updateTransporteUtilizado(hotelId,asientosIndividual,reservaId);
                }else{
                  console.log(response.data,'hay?');
                  console.log("El transporte no ha sido utilizado previamente"); //Insertar el transporte en la tabla de transportes_utilizados, luego: checkFroNull();
                  this.agregarTransporteSalida('1','1',hotelId,asientosIndividual,reservaId); //Luego updateTransporteUtilizado y enviar el restar (adultoss+ninos)
                  // if(cambio==1){ console.log("restaremos");
                  //   this.updateTransporteUtilizado(hotelId,asientosIndividual,reservaId);
                  // }
                }
              }
              
            }
          })
        }
    },
    agregarTransporteSalida (ruta,cambio,hotelId,asientosIndividual,reservaId) { //Ruta 1 = salida, Ruta 2 = Regreso
      console.log("Agregando transporte de salida");
      // axios.post('http://localhost:3000/justInsert',{
      //    table: 'transportes_utilizados',
      //    columns: 'fecha, transporteId, capacidad, ruta',
      //    values:` '${this.fecha}', '${this.transporteElegido.id}','${this.transporteElegido.capacidad}','${ruta}' `
      //  })
      var columns = 'fecha, transporteId, capacidad, ruta';
      var values=` '${this.fecha}', '${this.transporteElegido.id}','${this.transporteElegido.capacidad}','${ruta}' `;
      axios.get(`http://${this.host}/assignFunction.php?action=justInsert&tabla=transportes_utilizados&columns=${columns}&values=${values}`)
       .then((response) => {
         if (response.status == 200 ) {
           console.log('transporte agregado');
           if(cambio==1){ console.log("restaremos");
              this.updateTransporteUtilizado(hotelId,asientosIndividual,reservaId);
            }
         }else{
         }
       });
    },
    checkForNull(hotelId){
      // axios.post('http://localhost:3000/justRead', {
      //       select: 'total',
      //       table: "(SELECT id,tourId,cliente,adultos,ninos, (@total := @total+adultos+ninos) AS total FROM ((select * from reservaciones where hotelId="+hotelId+" and transporteSalidaId is null and fecha='"+this.fecha+"' and activo=1) as reservaciones, (select @total := 0) t) WHERE @total+adultos+ninos <= "+this.transporteElegido.capacidad+" order by total desc limit 1) as totalReserva",
      //       where: '',
      //       condition: ""
      //     })
      var select = `total`;
      var tabla = "(SELECT id,tourId,cliente,adultos,ninos, (@total := @total%2Badultos%2Bninos) AS total FROM ((select * from reservaciones where hotelId="+hotelId+" and transporteSalidaId is null and fecha='"+this.fecha+"' and activo=1) as reservaciones, (select @total := 0) t) WHERE @total%2Badultos%2Bninos <= "+this.transporteElegido.capacidad+" order by total desc limit 1) as totalReserva";
      var where = "";
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
          .then((response) => {
            if (response.status == 200) {
              console.log(response.data,'response.data');
              this.restar=response.data;
              // console.log(this.restar[0].total,'restar');
              if(this.restar[0]!=undefined){
                this.updateTransporteUtilizado(hotelId);
              }else{
                console.log("No caben más reservaciones");
                this.transporteElegido='';
                this.$snotify.warning('Sin lugares suficientes', 'No asignado', {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
              }
            }
          })
    },
    updateTransporteUtilizado (hotelId,asientos,reservaId) { console.log(hotelId,'updateando el transporte utilizado');
    if(asientos){ console.log(hotelId,asientos,reservaId,"1")
      // axios.post('http://localhost:3000/justUpdate',{
      //       table:"transportes_utilizados",
      //       set:" capacidad=capacidad-("+asientos+") ",
      //       where:"fecha='"+this.fecha+"' and transporteId="+this.transporteElegido.id+" and id>0 "
      //     })
      var tabla = `transportes_utilizados`;
      var set = "capacidad=capacidad-("+asientos+")";
      var where = "fecha='"+this.fecha+"' and transporteId="+this.transporteElegido.id+" and id>0";
      axios.get(`http://${this.host}/assignFunction.php?action=justUpdate&tabla=${tabla}&set=${set}&where=${where}`)
          .then((response) => {
            if (response.status == 200 ) {
              console.log("transporte utilizado ha sido updateado");
              this.getTransportes();
              this.asignarIndividual(reservaId);
            }else{
              console.log('error');
            }
          });
    }else{
      // axios.post('http://localhost:3000/justUpdate',{
      //       table:"transportes_utilizados",
      //       set:" capacidad=capacidad-("+this.restar[0].total+") ",
      //       where:"fecha='"+this.fecha+"' and transporteId="+this.transporteElegido.id+" and id>0 "
      //     })
      var tabla = `transportes_utilizados`;
      var set = "capacidad=capacidad-("+this.restar[0].total+")";
      var where = "fecha='"+this.fecha+"' and transporteId="+this.transporteElegido.id+" and id>0";
      axios.get(`http://${this.host}/assignFunction.php?action=justUpdate&tabla=${tabla}&set=${set}&where=${where}`)
          .then((response) => {
            if (response.status == 200 ) {
              console.log("transporte utilizado ha sido updateado");
              this.getTransportes();
              this.asignarTodos(hotelId);
            }else{
              console.log('error');
            }
          });
      }
    },
    asignarIndividual (reservaId) {
      console.log(reservaId,this.transporteElegido.id," jean hola k aze --------------");
      // axios.post('http://localhost:3000/justUpdate',{
      //         table:"reservaciones",
      //         set:" transporteSalidaId = "+this.transporteElegido.id,
      //         where:"id = "+reservaId
      //       })
      var tabla = `reservaciones`;
      var set = "transporteSalidaId = "+this.transporteElegido.id;
      var where = "id = "+reservaId;
      axios.get(`http://${this.host}/assignFunction.php?action=justUpdate&tabla=${tabla}&set=${set}&where=${where}`)
            .then((response) => {
              if (response.status == 200 ) {
                console.log('200 de asignando a idsToUpdate');
                this.transporteElegido='';
                this.reservaciones();
                this.hotelesConReservas();
                this.hotelesConReservasRiviera();
                this.transportesConReservas();
                this.reservacionesAsignadas();
                this.$snotify.success('1 Asignado', 'Correcto', {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
              }else{
                console.log('error');
              }
            });
    },
    asignarTodos (hotelId) {
      console.log(this.transporteElegido.capacidad,hotelId,'asignarTodos');
      var select = `id`;
      var tabla = "(SELECT id,tourId,cliente,adultos,ninos, (@total := @total%2Badultos%2Bninos) AS total FROM ((select * from reservaciones where hotelId="+hotelId+" and transporteSalidaId is null and activo=1) as reservaciones, (select @total := 0) t)";
      var where = "@total%2Badultos%2Bninos <= "+this.transporteElegido.capacidad+") as reservas";
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
      // axios.post('http://localhost:3000/justRead', { //Obtenemos idsToUpdatear
      //     select: ` id
      //   `,
      //     table: "(SELECT id,tourId,cliente,adultos,ninos, (@total := @total+adultos+ninos) AS total FROM ((select * from reservaciones where hotelId="+hotelId+" and transporteSalidaId is null and activo=1) as reservaciones, (select @total := 0) t)",
      //     where: "@total+adultos+ninos <= "+this.transporteElegido.capacidad+") as reservas",
      //     condition: ""
      //   })
        .then((response) => {
          if (response.status == 200) {
            this.idsList = response.data; console.log(response.data,'response.data');

            this.idsList = response.data;
            Object.keys(this.idsList).forEach((el) => {
              this.idsList[el]['objKey'] = parseInt(el)
            })
            this.idsList.forEach((item) => {
              this.idsToUpdate.push(item.id)
            })
            
            //Asignamos el transporte a cada id de reservación involucrado
            console.log(this.idsToUpdate,'idsTU');
            // axios.post('http://localhost:3000/justUpdate',{
            //   table:"reservaciones",
            //   set:" transporteSalidaId = "+this.transporteElegido.id,
            //   where:"id in ("+this.idsToUpdate+")"
            // })
            var tabla = `reservaciones`;
            var set = "transporteSalidaId = "+this.transporteElegido.id;
            var where = "id in ("+this.idsToUpdate+")";
            axios.get(`http://${this.host}/assignFunction.php?action=justUpdate&tabla=${tabla}&set=${set}&where=${where}`)
            .then((response) => {
              if (response.status == 200 ) {
                console.log('200 de asignando a idsToUpdate');
                this.transporteElegido='';
                this.idsToUpdate=[];
                this.reservaciones();
                this.hotelesConReservas();
                this.hotelesConReservasRiviera();
                this.transportesConReservas();
                this.reservacionesAsignadas();
                this.$snotify.success('Asignados', 'Correcto', {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
              }else{
                console.log('error');
              }
            });

          }
        })
    },
    reservaciones () {
      console.log(this.fecha,'fecha');
      var select = `tour.nombre as tour,
          reservaciones.adultos%2Breservaciones.ninos as asientos,
          tipo.nombre as tipo,
          lugar_salida.nombre as desde,
          nacionalidad.nombre as naciondalidad,
          idioma.nombre as idioma,
          reservaciones.*,
          vendedores.nombre as vendedorNombre,
          usuarios.nombre as usuarioNombre,
          monedas.nombre as monedaNombre`;
      var tabla = 'reservaciones, tour, tipo, lugar_salida, nacionalidad, idioma, vendedores, usuarios, monedas';
      var where = 'reservaciones.vendedorId=vendedores.id and reservaciones.usuarioIdCreado=usuarios.id and reservaciones.moneda=monedas.id and reservaciones.tourId=tour.id and reservaciones.tipoTourId=tipo.id and reservaciones.salidaId=lugar_salida.id and reservaciones.nacionalidadId=nacionalidad.id and reservaciones.idiomaId=idioma.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'" order by reservaciones.hotelId, reservaciones.cliente ';
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
       .then((response)=>{
         if (response.status == 200 ) { console.log("bien jean");
            console.log(response.data,'<-- response php server');
            this.reservacionesList = response.data;
            this.itemsSearched = response.data;
         }else{
           console.log('error: No reservado');
         }
       });
    },
    reservacionesAsignadas () {
      console.log(this.fecha,'fecha');
      // axios.post('http://localhost:3000/justRead', {
          // select: ` tour.nombre as tour,
          // tipo.nombre as tipo,
          // lugar_salida.nombre as desde,
          // nacionalidad.nombre as naciondalidad,
          // idioma.nombre as idioma,
          // reservaciones.*,
          // hoteles.nombre as hotelNombre,
          // vendedores.nombre as vendedorNombre,
          // monedas.nombre as monedaNombre
      //   `,
      //     table: "reservaciones, tour, tipo, lugar_salida, nacionalidad, idioma, hoteles, vendedores, monedas",
      //     where: 'reservaciones.vendedorId=vendedores.id and reservaciones.moneda=monedas.id and reservaciones.hotelId=hoteles.id and reservaciones.tourId=tour.id and reservaciones.tipoTourId=tipo.id and reservaciones.salidaId=lugar_salida.id and reservaciones.nacionalidadId=nacionalidad.id and reservaciones.idiomaId=idioma.id and reservaciones.transporteSalidaId is not null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'"',
      //     condition: "order by reservaciones.hotelId, reservaciones.cliente"
      //   })
      var select = `tour.nombre as tour,
          tipo.nombre as tipo,
          lugar_salida.nombre as desde,
          nacionalidad.nombre as naciondalidad,
          idioma.nombre as idioma,
          reservaciones.*,
          hoteles.nombre as hotelNombre,
          vendedores.nombre as vendedorNombre,
          monedas.nombre as monedaNombre`;
      var tabla = "reservaciones, tour, tipo, lugar_salida, nacionalidad, idioma, hoteles, vendedores, monedas";
      var where = 'reservaciones.vendedorId=vendedores.id and reservaciones.moneda=monedas.id and reservaciones.hotelId=hoteles.id and reservaciones.tourId=tour.id and reservaciones.tipoTourId=tipo.id and reservaciones.salidaId=lugar_salida.id and reservaciones.nacionalidadId=nacionalidad.id and reservaciones.idiomaId=idioma.id and reservaciones.transporteSalidaId is not null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'" order by reservaciones.hotelId, reservaciones.cliente ';
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data,'r data reserv');
            this.reservacionesAsignadasList = response.data;
          }
        })
    },
    hotelesConReservas () {
      // axios.post('http://localhost:3000/justRead', {
      //     select: 'hoteles.*,areas.nombre as areaNombre, (select sum(adultos) as adultosTotal from reservaciones where reservaciones.hotelId=hoteles.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") as pax, (select sum(ninos) as ninosTotal from reservaciones where reservaciones.hotelId=hoteles.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") as ninos',
      //     table: "hoteles,areas",
      //     where: 'hoteles.id in (select distinct hotelId from reservaciones where reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") and hoteles.area=areas.id',
      //     condition: "order by hoteles.area desc,hoteles.numero asc"
      //   })
      var select = 'hoteles.*,areas.nombre as areaNombre, (select sum(adultos) as adultosTotal from reservaciones where reservaciones.tipoReservacionId=1 and reservaciones.salidaId=1 and reservaciones.hotelId=hoteles.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") as pax, (select sum(ninos) as ninosTotal from reservaciones where reservaciones.tipoReservacionId=1 and reservaciones.salidaId=1 and reservaciones.hotelId=hoteles.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") as ninos';
      var tabla = "hoteles,areas";
      var where = 'hoteles.id in (select distinct hotelId from reservaciones where reservaciones.tipoReservacionId=1 and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") and hoteles.area=areas.id order by hoteles.area desc,hoteles.numero asc';
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then((response) => {
          if (response.status == 200) {
            this.hotelesReservados = response.data;
          }
        })
    },
    hotelesConReservasCombos () {
      // axios.post('http://localhost:3000/justRead', {
      //     select: 'hoteles.*,areas.nombre as areaNombre, (select sum(adultos) as adultosTotal from reservaciones where reservaciones.hotelId=hoteles.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") as pax, (select sum(ninos) as ninosTotal from reservaciones where reservaciones.hotelId=hoteles.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") as ninos',
      //     table: "hoteles,areas",
      //     where: 'hoteles.id in (select distinct hotelId from reservaciones where reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") and hoteles.area=areas.id',
      //     condition: "order by hoteles.area desc,hoteles.numero asc"
      //   })
      var select = 'hoteles.*,areas.nombre as areaNombre, (select sum(adultos) as adultosTotal from reservaciones where reservaciones.tipoReservacionId>1 and reservaciones.salidaId=1 and reservaciones.hotelId=hoteles.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") as pax, (select sum(ninos) as ninosTotal from reservaciones where reservaciones.tipoReservacionId>1 and reservaciones.salidaId=1 and reservaciones.hotelId=hoteles.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") as ninos';
      var tabla = "hoteles,areas";
      var where = 'hoteles.id in (select distinct hotelId from reservaciones where reservaciones.tipoReservacionId>1 and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") and hoteles.area=areas.id order by hoteles.area desc,hoteles.numero asc';
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then((response) => {
          if (response.status == 200) {
            this.hotelesReservadosCombos = response.data;
          }
        })
    },
    hotelesConReservasRiviera () {
      // axios.post('http://localhost:3000/justRead', {
      //     select: 'hoteles.*,areas.nombre as areaNombre, (select sum(adultos) as adultosTotal from reservaciones where reservaciones.hotelId=hoteles.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") as pax, (select sum(ninos) as ninosTotal from reservaciones where reservaciones.hotelId=hoteles.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") as ninos',
      //     table: "hoteles,areas",
      //     where: 'hoteles.id in (select distinct hotelId from reservaciones where reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") and hoteles.area=areas.id',
      //     condition: "order by hoteles.area desc,hoteles.numero asc"
      //   })
      var select = 'hoteles.*,areas.nombre as areaNombre, (select sum(adultos) as adultosTotal from reservaciones where reservaciones.salidaId>1 and reservaciones.hotelId=hoteles.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") as pax, (select sum(ninos) as ninosTotal from reservaciones where reservaciones.salidaId>1 and reservaciones.hotelId=hoteles.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") as ninos';
      var tabla = "hoteles,areas";
      var where = 'hoteles.id in (select distinct hotelId from reservaciones where reservaciones.salidaId>1 and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") and hoteles.area=areas.id order by hoteles.area desc,hoteles.numero asc';
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then((response) => {
          if (response.status == 200) {
            this.hotelesReservadosRiviera = response.data;
          }
        })
    },
    transportesConReservas () {
      // axios.post('http://localhost:3000/justRead', {
      //     select: '*',
      //     table: "transportes",
      //     where: "id in (select transporteId from transportes_utilizados where fecha='"+this.fecha+"') " ,
      //     condition: ""
      //   })
      var select = '*';
      var tabla = "transportes";
      var where = "id in (select transporteId from transportes_utilizados where fecha='"+this.fecha+"' and ruta=1 )";
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then((response) => {
          if (response.status == 200) {
            this.transportesReservados = response.data;
          }
        })
    },
    getTransportes () {
      // axios.post('http://localhost:3000/justRead', {
      //     select: `*
      //   `,
      //     table: "transportes",
      //     where: 'id not in (SELECT transporteId FROM transportes_utilizados where fecha="'+this.fecha+'") union SELECT transporteId as id,transportes.nombre as nombre, transportes_utilizados.capacidad as capacidad FROM transportes_utilizados,transportes where transportes_utilizados.transporteId=transportes.id and ruta=1 and fecha="'+this.fecha+'" order by id',
      //     condition: ""
      //   })
      var select = '*';
      var tabla = "transportes";
      var where = 'id not in (SELECT transporteId FROM transportes_utilizados where fecha="'+this.fecha+'") union SELECT transporteId as id,transportes.nombre as nombre, transportes_utilizados.capacidad as capacidad FROM transportes_utilizados,transportes where transportes_utilizados.transporteId=transportes.id and ruta=1 and fecha="'+this.fecha+'" order by id';
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then((response) => {
          if (response.status == 200) {
            this.transportesList = response.data;
          }
        })
    },
  },
  mixins: [searchMix]
}

</script>

<style scoped>
  .borderStyle {
  border-style: solid;
  border-color: #245b8c;
  border-width: 3px!important;
}
td {
  padding: 1px!important;
  }
.tituloHotel {
  background-color:#1E1E1E;
  color: white;
}
.tituloTransporte {
  background-color:#FFC3E5;
}
</style>
<style>

.div{
  padding-top:0px;
  padding-bottom:0px;
  text-align: center;
},
.e1 {
  background-color: #D6FFE6;
}
.e2 {
  background-color: #FFDEDB;
}
.e3 {
  background-color: #AEE2F9;
}
.e4 {
  background-color: #A4A4A5;
}
.e5 {
  background-color: #FFE2FE;
}
.e6 {
  background-color: #F9F9F9;
}
.arrow-up {
  width: 0; 
  height: 0; 
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #4c7ca5;
  margin-left:2.5rem;
}
.td:hover {
  background-color: #7aabd6;
}
.tooltip {
  display: block !important;
  z-index: 10000;
  }
.tooltip {
  display: block !important;
  z-index: 10000;
  }
  .tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
  }
  .tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  }
  .tooltip[x-placement^="bottom"] {
  margin-top: 5px;
  }
  .tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
  }
  .tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
  }
  .tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
  }
  table th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #fff;
    border: 1;
  }
</style>